exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit_title {\n  margin: 0 0 1rem 1rem; }\n\n.edit_rd_group {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 3rem;\n  margin: 1.5rem 1rem;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\nmat-header-row {\n  min-height: 25px; }\n\n.action_cell {\n  max-width: 10%; }\n\n.switch_demo {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 0.5rem;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  padding-left: 4.25rem; }\n\n.tables_wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 1rem;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin: 0 1rem 1rem 1rem; }\n  .tables_wrapper .card_type {\n    width: 100%;\n    max-width: 700px; }\n  .tables_wrapper .input_filter_type {\n    padding: 0 1rem; }\n\n.card-body {\n  padding: 1.25rem 0; }\n  .card-body .btn_wrapper {\n    display: -ms-flexbox;\n    display: flex;\n    gap: 1rem;\n    -ms-flex-pack: end;\n        justify-content: end;\n    margin: 0 1rem 1rem 1rem; }\n  .card-body .valorColuna {\n    text-align: end; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/dialog/node-user-dialog/node-user-dialog.component.scss
// module id = ../../../../../src/app/components/dialog/node-user-dialog/node-user-dialog.component.scss
// module chunks = main